<template>
  <div class="pravo-sirsi__welcome__banner">
    <h1 class="pravo-sirsi__welcome__banner__nadpis">
      Welcome to <a href="/about">Adgame.live</a>
    </h1>
    <div class="pravo-sirsi__welcome__banner__panel">
      <div class="pravo-sirsi__welcome__banner__panel__line"></div>
      <div class="pravo-sirsi__welcome__banner__panel__name">Adgame.live</div>
      <div class="pravo-sirsi__welcome__banner__panel__image">
        <div class="pravo-sirsi__welcome__banner__panel__image__img"></div>
      </div>
      <div class="pravo-sirsi__welcome__banner__panel__logo">
        <div class="pravo-sirsi__welcome__banner__panel__logo__img"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Banner",
};
</script>